import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';

const url = process.env.REACT_APP_API + '/repositories';

const RepositoryDialog = (props) => {
  const { ShowMessage } = useShowMessages();

  const handleChangeValues = (e) => {
    props.setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleClickSend = async () => {
    if (!props.values.url) {
      ShowMessage('error', 'Informe a URL do repositório');
      return;
    }

    try {
      await axios.post(url, { url: props.values.url });
      ShowMessage('success', 'Repositório adicionado com sucesso!');
      props.handleChanged();
      handleClose();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao adicionar repositório';
      ShowMessage('error', msg);
    }
  };

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogTitle>Novo Repositório</DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 1 }}>
          <TextField
            autoFocus
            name="url"
            value={props.values?.url || ''}
            label="URL do Repositório"
            placeholder="https://github.com/org/repo.git"
            type="text"
            onChange={handleChangeValues}
            fullWidth
            variant="filled"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ paddingRight: 3 }}>
        <Button onClick={handleClose} variant="outlined" color="error">Cancelar</Button>
        <Button onClick={handleClickSend} variant="outlined" color="success">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RepositoryDialog;
